import "./FoodAndBeverageSuccessCase.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Solutions from "./sections/Solutions";
import Certifications from "./sections/Certifications";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function FoodAndBeverageSuccessCasePage() {
  return <div>
      <Header />
      <Hero />
      <Solutions />
      <Certifications />
      <Consultation />
      <Footer />
    </div>;
}